import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog } from "@mui/material";
//import { IoSearch } from "react-icons/io5";
import GlobalSearchAutocomplete from "./global-search-autocomplete";
import IconNav from "../../nav-bar/icon-nav";
import "./global-search.scss";
import { useMuiScreenSizes } from "../../../hooks/useMuiScreenSizes";

const GlobalSearch = ({ iconMenu}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isScreenMedium } = useMuiScreenSizes();

  const handleSearchClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div>

          {iconMenu &&
              <IconNav
                  //label="Search"
                  label={iconMenu.subheader}
                  handleClick={handleSearchClick}>
                  {/*<IoSearch />*/}
                  {iconMenu.icon}
              </IconNav>
          }

      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        sx={{
          zIndex: 10000,
          "& .MuiDialog-paper": {
            height: isScreenMedium ? "80vh" : "60vh",
            borderRadius: 4,
            padding: isScreenMedium ? "0 17px 25px 17px" : "5px 26px 30px 26px"
          }
        }}
      >
        <GlobalSearchAutocomplete handleCloseSearch={handleClose} />
      </Dialog>
    </div>
  );
};

export default GlobalSearch;
GlobalSearch.propTypes = {
    iconMenu: PropTypes.object.isRequired,
};